import { render, staticRenderFns } from "./disconnected-authorization.vue?vue&type=template&id=55c0a0af&scoped=true&"
import script from "./disconnected-authorization.vue?vue&type=script&lang=js&"
export * from "./disconnected-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0a0af",
  null
  
)

export default component.exports